import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2470. 自分のアクセス可能受注案件概要一覧
 * [GET] /workspaces/:identifier/me/sales_orders
 */
type Props = {
  identifier: string;
};
const meSalesOrders = (props: Props): Promise<SalesOrderOutline[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/me/sales_orders`);
};

export const useMeSalesOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => meSalesOrders(props),
  });
};

export const useMeSalesOrdersInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'me', 'sales_orders'];
};
